/*eslint no-script-url: 0 */
import React, { Component } from "react";

class ContactUs extends Component {
  	render() {
	    return (
			<div className="footer-col clear-991">
				<h4>Contact Us</h4>
				<div className="add">
					<p>PO BOX 59 GLENFIELD NSW 2167 | Unit 1 & 2, 2 Liverpool St, Ingelburn NSW 2565</p>
				</div>
				<div className="email">
					<p>Email <a href="mailto:contact@JustPictureFraming.com.au">contact@JustPictureFraming.com.au</a></p>
				</div>
				<div className="email2">
					<p>Website <a href="http://www.JustPictureFramingOnline.com.au/">www.JustPictureFramingOnline.com.au</a></p>
				</div>
			</div>
	    );
  	}
} 
export default ContactUs;